<template>
  <div
    :style="{
      borderRadius: arrayToPx(config.box.borderRadius),
      backgroundColor: config.box.backgroundColor,
      height: '100%'
    }"
    class="grid-item--box"
  >
    <div
      class="grid-item--title"
      v-if="config.title.show"
      :style="{
        borderRadius: arrayToPx(config.title.borderRadius),
        padding: arrayToPx(config.title.padding),
        fontSize: `${config.title.fontSize}px`,
        color: config.title.color,
        height: `${config.title.height}px`,
        lineHeight: `${config.title.lineHeight}px`,
        fontWeight: config.title.fontWeight,
        backgroundColor: config.title.backgroundColor
      }"
    >
      {{ config.title.text }}
      <el-tooltip
        class="item"
        effect="dark"
        :content="config.title.titleContentInfo"
        placement="top-start"
        v-if="config.title.titleContentInfo&&config.title.titleContentInfo!==''"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
      <div
        v-if="config.frameLink"
        class="grid-item--actions grid-item--actions-link"
      >
        <template v-for="(link, linkIndex) of frameLink">
          <span :key="linkIndex" v-if="link.name">
            <span
              class="link-btn"
              :key="linkIndex"
              v-if="link.name"
              v-focusable
              @click="seeDetails(link.link)"
              :style="{...getRihStyle()}"
            >
              {{ link.name }}
            </span>
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    frameLink () {
      let temp = this.config.frameLink
      temp = temp.map(item => {
        return {
          name: item.children[0].value,
          link: item.children[1].value
        }
      })
      return temp
    }
  },
  methods: {
    arrayToPx (array) {
      return array.map(item => {
        return `${item}px`
      }).join(' ')
    },
    seeDetails (link) {
      localStorage.setItem('returnPage', location.pathname + location.search)
      window.top.location.href = link
    },
    getRihStyle () {
      let fontSize = this?.config?.rih?.fontSize ?? 'initial'
      return {
        fontSize: fontSize === 'initial' ? fontSize : fontSize + 'px',
        backgroundColor: this?.config?.rih?.fontSize ?? 'initial'
      }
    }
  },
  created () {}
}
</script>

<style lang="stylus" scoped>
.grid-item--box
  width 100%
  height 100%
  background #1c1839
  border-radius 10px
  .grid-item--title
    height 50px
    line-height 50px
    background #1f1e44
    padding 0 30px
    color #fff
    font-size 20px
    border-radius 10px 10px 0 0
    position relative
    .grid-item--actions
      position absolute
      right 15px
      top 13px
      // z-index 999999
      .link-btn
        flex 1
        height 26px
        line-height 26px
        padding 0 10px
        font-size 12px
        cursor pointer
        background-color #000
        color #fff
        margin-left 10px
        float right
        border-radius 5px
        display flex
        align-items center
      .link-btn.btnFocus
        background #007eff
        color #fff
</style>
